var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#paint0_linear_18174_127197)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4949 24.5225C19.3322 22.1032 23.2246 20.5083 25.1722 19.7377C30.733 17.5375 31.8885 17.1553 32.6416 17.1427C32.8073 17.1399 33.1776 17.179 33.4175 17.3642C33.6201 17.5205 33.6758 17.7318 33.7025 17.88C33.7292 18.0282 33.7624 18.366 33.736 18.6298C33.4347 21.6417 32.1308 28.9508 31.4674 32.3241C31.1867 33.7515 30.6341 34.2301 30.099 34.2769C28.9362 34.3787 28.0532 33.5459 26.927 32.8437C25.1646 31.7447 24.169 31.0606 22.4583 29.9883C20.4814 28.749 21.763 28.0679 22.8896 26.9547C23.1845 26.6634 28.3079 22.2304 28.407 21.8283C28.4194 21.778 28.4309 21.5905 28.3138 21.4915C28.1968 21.3926 28.024 21.4264 27.8993 21.4533C27.7225 21.4915 24.9071 23.2616 19.4532 26.7638C18.654 27.2858 17.9302 27.5401 17.2817 27.5268C16.5667 27.5121 15.1915 27.1422 14.1691 26.8261C12.9151 26.4383 11.9185 26.2333 12.0053 25.5748C12.0505 25.2318 12.547 24.881 13.4949 24.5225Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18174_127197",
    x1: 2400,
    y1: 0,
    x2: 2400,
    y2: 4764.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.74babbb3.svg";
export { ForwardRef as ReactComponent };